import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface UserSignature {
  user_id: string;
  image_url: string;
  link_url?: string | null;
  enabled: boolean;
  updated_at: string;
}

export function useSignature(userId?: string | null) {
  const [data, setData] = useState<UserSignature | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    let cancelled = false;
    if (!userId) {
      setData(null);
      return;
    }
    const run = async () => {
      setLoading(true);
      setError(null);
      try {
        const { data, error } = await supabase
          .from('profile_signatures')
          .select('user_id,image_url,link_url,enabled,updated_at')
          .eq('user_id', userId)
          .single();
        if (!cancelled) {
          if (error) {
            setError(error);
            setData(null);
          } else {
            setData((data as any) || null);
          }
        }
      } catch (e) {
        if (!cancelled) setError(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, [userId]);

  return { data, loading, error } as const;
}
